var _clipPath, _clipPath2, _clipPath3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.3333 1333.3333",
    height: 30,
    width: 30,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath24",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M 2935.77,4922.8 V 4002.98 L 4177.15,2761.61 V 4922.8 Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient32",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,4322.37,4322.37,0,3556.46,1943.76)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop26",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#4153ad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop28",
    offset: 0.664804,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop30",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath42",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M 4379.31,6384.59 V 2559.44 l 191.37,-191.37 c 237.11,-237.1 621.53,-237.1 858.64,0 l 191.37,191.37 v 3825.15 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient50",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,4840.35,4840.35,0,5000,1920.32)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop44",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#4153ad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop46",
    offset: 0.664804,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop48",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath60",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path58",
    d: "M 5822.85,7848.45 V 2761.61 l 1241.38,1241.37 v 3845.47 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient68",
    spreadMethod: "pad",
    gradientTransform: "matrix(0,4993.67,4993.67,0,6443.54,1913.4)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop62",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#4153ad"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop64",
    offset: 0.664804,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop66",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#ffffff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1333.3333)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 10130,-103.301 H -83.332 V 10110 H 10130 V -103.301"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5000,8000.37 c -213.09,0 -413.43,-82.98 -564.11,-233.66 l -2202.6,-2202.6 c -311.05,-311.05 -311.05,-817.17 0,-1128.22 l 2202.6,-2202.6 c 150.68,-150.68 351.02,-233.66 564.11,-233.66 213.09,0 413.43,82.98 564.11,233.66 l 2202.6,2202.6 c 311.05,311.05 311.05,817.17 0,1128.22 l -2202.6,2202.6 c -150.68,150.68 -351.02,233.66 -564.11,233.66 z m 0,-190.61 c 155.38,0 310.77,-59.28 429.32,-177.83 L 7631.93,5429.32 c 237.1,-237.11 237.1,-621.53 0,-858.64 L 5429.32,2368.07 C 5310.77,2249.52 5155.38,2190.24 5000,2190.24 c -155.38,0 -310.77,59.28 -429.32,177.83 L 2368.07,4570.68 c -237.1,237.11 -237.1,621.53 0,858.64 l 2202.61,2202.61 c 118.55,118.55 273.94,177.83 429.32,177.83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath24)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2935.77,4922.8 V 4002.98 L 4177.15,2761.61 V 4922.8 H 2935.77"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g36"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath42)",
    id: "g38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 4379.31,6384.59 V 2559.44 l 191.37,-191.37 c 237.11,-237.1 621.53,-237.1 858.64,0 l 191.37,191.37 V 6384.59 H 4379.31"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g54"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath60)",
    id: "g56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 5822.85,7848.45 V 2761.61 L 7064.23,4002.98 V 7848.45 H 5822.85"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.d9b392c415286ee3e0e0701da0e55b93.svg";
export { ForwardRef as ReactComponent };